import { useEffect, useState } from 'react'
import { ShowWithImages } from 'types/Show'

import { useEventsByShowIds } from '../useEvents'

export const useFilteredShowsByYear = (shows: ShowWithImages[], year: number) => {
    const [filteredShows, setFilteredShows] = useState<ShowWithImages[]>([])
    const showIds = shows.map((show) => show.show_id)
    const { eventsByShowId, isLoading, error } = useEventsByShowIds(showIds)

    useEffect(() => {
        if (eventsByShowId && !isLoading) {
            const showsWithEvents = shows.filter((show) => {
                const eventsForShow = eventsByShowId.filter((event) => event.show_id === show.show_id)

                const hasEventInYear = eventsForShow.some((event) => {
                    const eventYear = new Date(event.event_date).getFullYear()
                    return eventYear === year
                })

                return hasEventInYear
            })

            setFilteredShows(showsWithEvents)
        }
    }, [eventsByShowId, isLoading, shows, year])

    return { filteredShows, isLoading, error }
}
